import React, { useCallback, useContext, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { normalizeChannel, getDeviceForChannel } from '../../utils/responsive';
import { trackEvent } from '../../tracking';
import PageSections from '../../pages/PageSections';

export const NationalService = () => {
  const { slug, serviceId } = useParams();
  const { pathname, hash } = useLocation();

  const isContentfulPreview = pathname.includes('/contentPV/');
  const { channel } = useContext(ExperienceContext);
  const normalizedChannel = normalizeChannel(channel);
  const device = getDeviceForChannel(normalizedChannel);

  const serviceProps = {
    slug,
    serviceId,
    pageName: 'NationalService',
    isContentfulPreview,
    hashId: hash?.replace('#', ''),
    device
  };

  const handleAnalyticsEvent = useCallback((eventInput, properties = {}) => {
    const pageContext = {
      page: 'NationalService',
      slug,
      ...(serviceId && { serviceId }),
      timestamp: new Date().toISOString()
    };

    if (eventInput && typeof eventInput === 'object') {
      trackEvent(eventInput, { ...properties, ...pageContext });
      return;
    }

    trackEvent(eventInput, { ...properties, ...pageContext });
  }, [slug, serviceId]);

  useEffect(() => {
    trackEvent('Page Load', {
      name: 'NationalService',
      slug,
      ...(serviceId && { serviceId }),
      timestamp: new Date().toISOString()
    });
  }, [slug, serviceId]);

  return (
    <PageSections serviceProps={serviceProps} trackEvent={handleAnalyticsEvent} />
  );
};

export default NationalService;
